(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["second-spring-natural-balance"] && !Shopify.designMode) return;
  try {
    
function initNaturalSliders(scope=document){
 scope.querySelectorAll('[data-natural-slider]').forEach(root=>{
  if(root.dataset.sliderReady)return;root.dataset.sliderReady='true';
  const track=root.querySelector('.ss-natural-cards'),cards=[...track.children],prev=root.querySelector('[data-natural-prev]'),next=root.querySelector('[data-natural-next]'),status=root.querySelector('[data-natural-status]'),dots=[...root.querySelectorAll('[data-natural-dot]')];
  const index=()=>Math.min(cards.length-1,Math.round(track.scrollLeft/(cards[0].getBoundingClientRect().width+14)));
  function paint(){const i=track.scrollLeft>=track.scrollWidth-track.clientWidth-2?cards.length-1:index();status.textContent=(i+1)+' / '+cards.length;dots.forEach((dot,n)=>dot.setAttribute('aria-current',String(n===i)));prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;}
  function move(direction){const step=cards[0].getBoundingClientRect().width+14;track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:i*(cards[0].getBoundingClientRect().width+14),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',paint,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});new ResizeObserver(paint).observe(track);paint();
 });
}
initNaturalSliders();document.addEventListener('shopify:section:load',e=>initNaturalSliders(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["second-spring-results"] && !Shopify.designMode) return;
  try {
    
function initStories(scope=document){scope.querySelectorAll('[data-stories]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-story-track]'),cards=[...track.children],dots=root.querySelector('[data-story-dots]'),prev=root.querySelector('[data-story-prev]'),next=root.querySelector('[data-story-next]');if(!cards.length)return;let perPage=0;const step=()=>cards[0].getBoundingClientRect().width+20;const current=()=>Math.min(Math.ceil(cards.length/perPage)-1,Math.round(track.scrollLeft/(step()*perPage)));function go(i){track.scrollTo({left:i*step()*perPage,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}function paint(){const last=track.scrollLeft>=track.scrollWidth-track.clientWidth-2,i=last?dots.children.length-1:current();[...dots.children].forEach((b,n)=>b.setAttribute('aria-current',String(i===n)));prev.disabled=track.scrollLeft<2;next.disabled=last}function resize(){const n=innerWidth<=767?1:3;if(n!==perPage){perPage=n;dots.replaceChildren();for(let i=0;i<Math.ceil(cards.length/perPage);i++){let b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Go to review page '+(i+1));b.addEventListener('click',()=>go(i));dots.append(b)}}paint()}prev.addEventListener('click',()=>go(current()-1));next.addEventListener('click',()=>go(current()+1));track.addEventListener('scroll',paint,{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current()+(e.key==='ArrowRight'?1:-1))}});new ResizeObserver(resize).observe(track);resize()})}initStories();document.addEventListener('shopify:section:load',e=>initStories(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-home-header"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click', function(event) {
   if (event.target.closest('.ssh-mobile-menu a')) event.target.closest('details').open = false;
 });

  } catch(e) { console.error(e); }
})();
})();
